import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { Location } from '@angular/common';
import { ProgramService } from '../../programs/shared/program.service';
import { RequestService } from '../../requets/shared/request.service';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';
import { Version } from '../../programs/shared/version.model';
import { RequestDetailEvaluatorComponent } from '../request-detail-evaluator/request-detail-evaluator.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ChangeVersionDialogComponent } from '../change-version-dialog/change-version-dialog.component';
import { ChangedVersion } from '../../programs/shared/changed-version.model';
import { SaveDescriptionDialogComponent } from 'src/app/core/modal/save-description-dialog/save-description-dialog.component';

import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { DenyRequest } from '../../requets/shared/model/deny-request';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-assess',
  templateUrl: './assess.component.html',
  styleUrls: ['./assess.component.scss']
})
export class AssessComponent implements OnInit {

  request: RequestReponse;
  requestDetail: RequestDetailEvaluator[];
  versions: Version[] = [];
  messageError: String = '';
  claseMessage: String = 'messaje-error';
  enabledSpinner = false;
  timeLeft: number = 4;
  interval;

  @ViewChild(RequestDetailEvaluatorComponent) requestDetailEvaluatorComponent: RequestDetailEvaluatorComponent;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private dialog: MatDialog,
              private programsService: ProgramService,
              private requestService: RequestService,
              private location: Location) {

    this.route.queryParams.subscribe(
      (params) => {
        this.request = JSON.parse(params['request']);
        this.getVersions();
        this.getRequestDetail();
      }
    );
  }

  ngOnInit() {
  }

  back() {
    // this.location.back();
    this.router.navigate(['evaluaciones']);
  }

  decline() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Esta seguro que desea Rechazar las materias?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.openDilogDeny();
        }
    });
  }

  evaluate() {
    const queryParams = {
      request: this.request,
      subjects: this.requestDetailEvaluatorComponent.selection.selected,
    };
    const param = JSON.stringify(queryParams);
    this.router.navigate(['evaluaciones/evaluar/materias'], { queryParams: { param : param } });
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { cedula: this.request.solicitud.cedula,
                           nombre : this.request.nombreEstudiante,
                           programa:  this.request.programa.codigo + ' - ' + this.request.programa.nombre,
                           version: this.request.programa.version,
                           versions: this.versions};
                           console.log( dialogConfig.data);
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(ChangeVersionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result !== null) {
          this.enabledSpinner = true;
            const changeVersion = new ChangedVersion();
            changeVersion.cedula = this.request.solicitud.cedula;
            changeVersion.programa = this.request.programa.codigo;
            changeVersion.versionActual = this.request.programa.version;
            changeVersion.nuevaVersion =  result.version;
            const newVersion =  result.version;
            changeVersion.justificacion =  result.justification;
            this.programsService.setVersionProgramStudent(changeVersion).subscribe(
              (result) => {
                this.enabledSpinner = false;
                if (result.data) {
                    if (result.data === 'OK') {
                      this.claseMessage = 'messaje-success';
                      this.messageError = 'Se cambio con éxito la versión' ;
                      this.request.programa.version =  newVersion;
                      this.startTimer();
                    } else {
                        this.claseMessage = 'messaje-error';
                        this.messageError = result.data ;
                    }
                }
              }
            );
        }
      }
    );
  }
  validateSeletion() {
    if (this.requestDetailEvaluatorComponent) {
      if (this.requestDetailEvaluatorComponent.selection.selected.length > 0) {
        return false;
      }
    }
    return true;
  }
  private startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.messageError = '';
        this.back();
      }
    }, 1000);
  }

  private openDilogDeny() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'RECHAZAR SOLICITUD', filedName: 'Justificación' };
    dialogConfig.width = '50%';
    const dialogRef = this.dialog.open(SaveDescriptionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const deny = new DenyRequest();
          deny.solicitud = this.request.solicitud.solicitud;
          deny.justificacion = value;
          deny.consecutivos = this.requestDetailEvaluatorComponent.selection.selected.map(
              (detail: RequestDetailEvaluator ) => detail.consecutivo + ''
            );
          this.enabledSpinner = true;
          this.requestService.denyRequets(deny).subscribe(
            (result) => {
              if (result.data) {
                this.enabledSpinner = false;
                if (result.data === 'OK') {
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se rechazaron las solicitudes seleccionadas';
                  this.getVersions();
                  this.getRequestDetail();
                  this.requestDetailEvaluatorComponent.selection = new SelectionModel<RequestDetailEvaluator>(true, []);
                } else {
                  this.claseMessage = 'messaje-error';
                  this.messageError = result.data;
                }
              }
            }
          );
      }
    });
  }
  private getRequestDetail() {
    const cedula = localStorage.getItem('cedula');
    this.requestService.getDetailRequets(this.request.solicitud.solicitud, 1, cedula, null).subscribe(
      (result) => {
        if (result.data) {
          if (result.data.length > 0) {
            this.requestDetail = result.data as RequestDetailEvaluator[];
          } else {
            this.router.navigate(['evaluaciones']);
          }
        }
      }
    );
  }

  private getVersions() {
    this.programsService.getVersions(this.request.programa.codigo).subscribe(
      (result) => {
        if (result.data) {
          this.versions = result.data as Version[];
        }
      }
    );
  }


}
